import type { PseoCatalog } from "./types";

import catalog from "@/content/pseo/catalog.json";

export function getPseoCatalog(): PseoCatalog {
  return catalog as PseoCatalog;
}
